export const en = {
  modal: {
    title: 'Upgrade to Pro Today',
    description: 'Unlock the Power of Simpli5 & Unlock the Power of You with a full Professional Account.',
    list: [
      {
        title: 'Discover your Superpowers: ',
        description:
          'Dive deeper into what makes you, you and learn how to work with your energies to achieve your personal and professional goals with greater ease.',
      },
      {
        title: 'Connect with SenSai Anytime, Anywhere: ',
        description:
          'Like having a friend, coach, and confidante accessible to you 24/7; SenSai is a thought partner, sounding board, and personal cheerleader in your pocket. Whatever is on your plate, SenSai is ready to help you manage it.',
      },
      {
        title: 'Reenergize your Relationships: ',
        description:
          'See the people around you in a new light and better understand the interpersonal dynamics at play for stronger, better relationships with detailed reports and insights.',
      },
    ],
    submitDescription: 'Your administrator needs to approve your account upgrade',
    purchaseDescription:
      'Purchase licenses directly to unlock Pro features instantly, or route to your manager to upgrade!',
    purchaseDirectly: 'Purchase a full license to immediately upgrade your account and unlock all Pro features.',
    seeMoreLink: 'See more',
    purchaseButton: 'Buy Now!',
    submitButton: 'Request an Upgrade',
    successMessage: 'Your request has been sent to your manager successfully',
  },
}

export const es = en
